import type { ReactNode } from 'react';

export function FormRow({
  label,
  children,
  hint,
  required,
}: {
  label: ReactNode;
  children: ReactNode;
  hint?: ReactNode;
  required?: boolean;
}) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium uppercase tracking-wide text-slate-600">
        {label}
        {required && <span className="ml-0.5 text-rose-500">*</span>}
      </span>
      {children}
      {hint && <span className="mt-1 block text-xs text-slate-500">{hint}</span>}
    </label>
  );
}
